<template src="./Universes.html"></template>
<style lang="scss" scoped src="./Universes.scss"></style>

<script>
import {
  SfHeading,
  SfSection,
  SfLink,
  SfImage
} from '@storefront-ui/vue';
import OrkLoader from "@/components/Ork/OrkLoader";
import Api from "@/api/Api";

export default {
  name: "Universes",
  components: {
    SfHeading,
    SfSection,
    SfLink,
    SfImage,
    OrkLoader
  },
  data() {
    return {
      title: null,
      description: null,
      carts: null,
      loading: false
    }
  },
  created() {
    this.getUniverse()
  },
  methods: {
    getUniverse() {
      this.loading = true
      Api.marketing.getUniverse()
          .then((data) => {
            this.title = data.title;
            this.description = data.description;
            this.carts = data.universes
          })
          .catch((e) => {
          })
          .finally(this.loading = false)
    },
    open(link) {
      window.location = link
    },
    getUniverseLocalizedPath(path) {
      if (path.startsWith('http')) {
        return path;
      }

      return this.$localizePath(path);
    }
  }

};
</script>